import { User } from "@auth0/auth0-react";
import { headers } from "src/config/utils";
import { AUTH0_REDIRECT_URI } from 'src/services/utils';

class AuthInterceptor {
    private getToken?: () => Promise<string>;
    private authUser?: User;
    private isAuth?: boolean;

    setAuthGetter(getToken: () => Promise<string>, authUser: User, isAuth: boolean) {
      this.getToken = getToken;
      this.authUser = authUser;
      this.isAuth = isAuth;
    }
  
    async interceptConfig(config) {
        if (!this.getToken || !this.authUser) {
            return config;
        }
  
        try {
            const accessToken = await this.getToken();
            const user = this.authUser;
            accessToken && (config.headers[headers.AUTHORIZATION] = `Bearer ${accessToken}`);
            user && (config.headers[headers.X_AUTHORIZATION_EMAIL] = user.email);
        } catch (e) {
            console.log(e);
        }
        return config;
    }   

    async interceptErrorResponse(error, isProduction) {
        const originalRequest = error.config;

        if (error?.response) {
          if (error.response?.status === 401 && originalRequest.url === `${AUTH0_REDIRECT_URI}/login`) {
            !isProduction && console.error(`¡Usuario no autorizado!`);
            if (this.isAuth) return;
            throw new Error('Usuario no autenticado');
          }
        }
        !isProduction && console.error(`Error interceptor response: ${error}`);
        throw error;
      }
  }
  
  export const authInterceptor = new AuthInterceptor()